import { useEffect, useState, useRef } from "react";
import { StatComponent } from "../../components";
import { Container } from "./styled";
import { calculatePlayerStats } from "../../lib/cabbStats";
import { LeaguePlayersStats } from "../../lib/leaguePlayersStats";

export default function ComparisonStatTable({
  gamesPlayed,
  league,
  activeSeason,
  gamesByLeague,
  isDnD,
  players,
  setActiveProfile,
  activeGames,
  activeProfileId,
  teams,
  activeProfile,
  activeHistoryTeam,
}) {
  const [stats, setStats] = useState({
    maxPlayersPts: null,
    maxPlayerReb: null,
    maxPlayerAss: null,
    maxPlayerStl: null,
    maxPlayerBlk: null,
    maxPlayerTor: null,
  });

  const statContainerRef = useRef(null);

  useEffect(() => {
    const fetchData = () => {
      if (!players) return;
      const pts = LeaguePlayersStats(
        players,
        activeGames,
        activeSeason,
        teams,
        activeProfile,
        "PTS",
        activeHistoryTeam
      );
      const reb = LeaguePlayersStats(
        players,
        activeGames,
        activeSeason,
        teams,
        activeProfile,
        "REB",
        activeHistoryTeam
      );
      const ass = LeaguePlayersStats(
        players,
        activeGames,
        activeSeason,
        teams,
        activeProfile,
        "ASS",
        activeHistoryTeam
      );
      const stl = LeaguePlayersStats(
        players,
        activeGames,
        activeSeason,
        teams,
        activeProfile,
        "STL",
        activeHistoryTeam
      );
      const blk = LeaguePlayersStats(
        players,
        activeGames,
        activeSeason,
        teams,
        activeProfile,
        "BLK",
        activeHistoryTeam
      );
      const tor = LeaguePlayersStats(
        players,
        activeGames,
        activeSeason,
        teams,
        activeProfile,
        "TOR",
        activeHistoryTeam
      );

      setStats({
        maxPlayersPts: pts?.[0] || null,
        maxPlayerReb: reb?.[0] || null,
        maxPlayerAss: ass?.[0] || null,
        maxPlayerStl: stl?.[0] || null,
        maxPlayerBlk: blk?.[0] || null,
        maxPlayerTor: tor?.[0] || null,
      });
    };
    fetchData();
  }, [
    league,
    activeSeason,
    players,
    gamesByLeague,
    activeGames,
    activeProfileId,
    activeHistoryTeam,
  ]);

  // Handle hover effects using React refs instead of direct DOM manipulation
  useEffect(async () => {
    const container = statContainerRef.current;
    if (!container) return;

    const progressCircles = container.querySelectorAll(".progress-circle");

    const handleMouseOver = () => {
      progressCircles.forEach((circle) => {
        circle.classList.add("hovered-hide");
      });
    };

    const handleMouseOut = () => {
      progressCircles.forEach((circle) => {
        circle.classList.remove("hovered-hide");
      });
    };

    await progressCircles.forEach((circle) => {
      circle.addEventListener("mouseover", handleMouseOver);
      circle.addEventListener("mouseout", handleMouseOut);
      circle.addEventListener("touchstart", handleMouseOver);
      circle.addEventListener("touchend", handleMouseOut);
    });

    return () => {
      progressCircles.forEach((circle) => {
        circle.removeEventListener("mouseover", handleMouseOver);
        circle.removeEventListener("mouseout", handleMouseOut);
        circle.removeEventListener("touchstart", handleMouseOver);
        circle.removeEventListener("touchend", handleMouseOut);
      });
    };
  }, [stats]);

  return (
    <>
      {isDnD ? (
        <select
          onChange={(e) => {
            setActiveProfile(e.target.value);
          }}
        >
          <option value="">Selecciona jugador</option>
          {players !== null &&
            players !== undefined &&
            players
              .filter((player) => player.active_team !== "undefined")
              .sort((a, b) => {
                const fullNameA = `${a.player_name
                  ?.toUpperCase()
                  .trimStart()} ${a.player_lastname
                  ?.toUpperCase()
                  .trimStart()}`;
                const fullNameB = `${b.player_name
                  ?.toUpperCase()
                  .trimStart()} ${b.player_lastname
                  ?.toUpperCase()
                  .trimStart()}`;
                return fullNameA.localeCompare(fullNameB);
              })
              .map((player, index) => (
                <option value={player._id}>
                  {`${player.player_name
                    ?.toUpperCase()
                    .trimStart()} ${player.player_lastname
                    ?.toUpperCase()
                    .trimStart()}`}
                </option>
              ))}
        </select>
      ) : null}
      <Container isDnD={isDnD}>
        <StatComponent
          data={calculatePlayerStats(activeGames, activeProfileId, "PTS")}
          text="Puntos"
          comparisonValue={stats.maxPlayersPts}
        />
        <StatComponent
          data={calculatePlayerStats(activeGames, activeProfileId, "REB")}
          text="Rebotes"
          comparisonValue={stats.maxPlayerReb}
          className="hover-container"
        />
        <StatComponent
          data={calculatePlayerStats(activeGames, activeProfileId, "ASS")}
          text="Asistencias"
          comparisonValue={stats.maxPlayerAss}
          className="hover-container"
        />
        <StatComponent
          data={calculatePlayerStats(activeGames, activeProfileId, "STL")}
          text="Robos"
          comparisonValue={stats.maxPlayerStl}
          className="hover-container"
        />
        <StatComponent
          data={calculatePlayerStats(activeGames, activeProfileId, "BLK")}
          text="Tapas"
          comparisonValue={stats.maxPlayerBlk}
          className="hover-container"
        />
        <StatComponent
          data={calculatePlayerStats(activeGames, activeProfileId, "TO")}
          text="Perdidas"
          comparisonValue={stats.maxPlayerTor}
          className="hover-container"
        />
      </Container>
    </>
  );
}
